











import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Display a title text
 */
@Component
export default class Title extends Vue {
  /** Level of the title */
  @Prop({ type: Number, default: 1 }) level!: number;
}
